import { css } from "styled-components";
import { BladeHeader, BladeHeaderBody, BladeHeaderTitle } from "../../../../../../components/BladeHeader";
import { BackdropForeground } from "../../../../../../components/Backdrop";
import { BladeContent } from "../../../../../../components/BladeContent";
import { textUppercaseMixin } from "../../../../../../skins/shared/mixins/typography";
export const betaMastheadSizes = {
    minHeightDesktop: "884px",
    minHeightTablet: "880px",
    minHeightMobile: "661px",
};
export const gameIconSizes = {
    desktopWidth: "70px",
    tabletWidth: "54px",
    mobileWidth: "43px",
};
export const contentSpaces = {
    horizontalDesktopPadding: "177px",
    horizontalTabletPadding: "94px",
    verticalTabletPadding: "88px",
    desktopAndTablet: "32px",
    mobile: "24px",
    desktopAndTabletSmall: "16px",
    mobileSmall: "12px",
};
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    max-width: 100%;
    background-color: ${paletteTokens.bladebg1};
    min-height: ${betaMastheadSizes.minHeightDesktop};
    padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
    display: flex;
    align-items: center;

    &.full-height-masthead {
      min-height: calc(100vh - 80px);
    }
  }

  .game-icon-no-label {
    .game-icon {
      height: 27px;
      margin-bottom: 32px;

      ${chroma.mediaQueries.tabletDown} {
        margin-bottom: 24px;
      }

      .game-icon-img {
        width: auto;
        height: 100%;
      }
    }
  }

  .game-icon-and-label {
    ${chroma.mediaQueries.mobileDown} {
      margin-bottom: ${contentSpaces.mobile};
    }

    display: flex;
    align-items: center;
    margin-bottom: ${contentSpaces.desktopAndTablet};
    user-select: none;

    .game-label-text {
      color: ${paletteTokens.bladetext2};
      ${chroma.typography.body1};
      font-weight: bold;
      ${textUppercaseMixin}
    }

    .game-label-img {
      height: 27px;
      margin-right: 18px;
      ${chroma.mediaQueries.mobileDown} {
        height: 21px;
        margin-right: 10px;
      }
    }
  }

  .platform-icons {
    display: flex;
    margin-bottom: ${contentSpaces.desktopAndTablet};
    flex-wrap: wrap;
    justify-content: space-around;

    img,
    svg {
      margin-right: 25px;
    }
  }

  .gradient-container {
    height: 100%;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;

    @media (width <= 1280px) {
      background: linear-gradient(40deg, ${chroma.palette.primary}e6 42.68%, ${chroma.palette.primary}00 69.38%);
    }

    ${chroma.mediaQueries.mobileDown} {
      background-image: linear-gradient(31deg, ${chroma.palette.primary}e6 46.38%, ${chroma.palette.primary}00 77.79%);
    }

    @media (width >= 1281px) {
      display: none;
    }
  }

  ${BackdropForeground} {
    display: block;
    width: 100%;
    top: auto;
    bottom: auto;
    left: auto;

    > img {
      height: 100%;
      width: auto;
      float: right;
      object-fit: cover;
      object-position: 50% 100%;
    }
  }

  ${BladeHeader} {
    position: relative;
    white-space: pre-line;
    max-width: 647px;
    width: 100%;
  }

  ${BladeHeaderTitle} {
    h2 {
      ${chroma.typography.display3};
      color: ${paletteTokens.bladetext1};
      ${textUppercaseMixin}
      text-wrap: balance;
    }

    h2::after {
      display: none;
    }
  }

  .beta-masthead-header {
    font-weight: 400;
    margin-bottom: ${contentSpaces.desktopAndTabletSmall};
  }

  ${BladeContent} {
    padding: 0 ${chroma.spacers.variable.xxl};
  }

  ${BladeHeaderBody} {
    margin-bottom: ${contentSpaces.desktopAndTablet};
  }

  ${chroma.mediaQueries.tabletDown} {
    min-height: ${betaMastheadSizes.minHeightTablet};
    display: flex;
    align-items: end;
    padding: ${contentSpaces.verticalTabletPadding} 0;

    ${BackdropForeground} {
      right: 0;
    }
  }

  ${chroma.mediaQueries.mobileDown} {
    min-height: ${betaMastheadSizes.minHeightMobile};
    padding: 0;

    ${BladeContent} {
      padding: ${contentSpaces.mobile};
    }

    a.primary-cta {
      width: fit-content;
    }

    .beta-masthead-header,
    .platform-icons,
    ${BladeHeaderBody} {
      margin-bottom: ${contentSpaces.mobile};
    }
  }
`;
//# sourceMappingURL=index.js.map